import _ from 'lodash'
import * as THREE from 'three'
import BaseTool from '@glass-designer/tools/baseTool'
import EditingRectangle from '@glass-designer/objects/editingRectangle'
import MathsUtils from '@/utils/mathsUtils'
import EditorClipper from '@glass-designer/utils/editorClipper'
import { EditorUserError } from '@glass-designer/utils/editorErrors'

import Config from '@glass-designer/config'
import GlassDesignerTypes from '@glass-designer/types'


// Shape tool
// Tool to draw circle / rectangle shapes on the glass shape item to be used with boolean operations (eg, add or remove)

// DEPRECATED
export default class ShapeTool extends BaseTool {
  constructor(editor) {
    super(editor)

    this.type = GlassDesignerTypes.ToolTypes.shapeTool

    // Setup the rectangle editing shape object
    this.editingRectShape = new EditingRectangle(this.editor)
    this.editingRectShape.setVisible(false)
    this.editingRectShape.setObjectEventListener(this)
    this.addChildObject(this.editingRectShape)
  }

  // Tool Active
  // Called when the tool is active
  onToolActive(options = {}) {
    super.onToolActive()

    this.editor.setDimensionsEnabled([GlassDesignerTypes.DimensionTypes.editingLineDimension])
    this.editor.setShapeSelectionEnabled(false)

    // Start the shape creation
    this.resetShapeEditing()

    // TEMP
    this.editingRectShape.setVisible(true)

    this.displayToolSettingsPopover()
  }

  // Tool Inactive
  // Called when the tool is no longer active
  onToolInactive() {
    super.onToolInactive()

    this.editor.resetDimensionsEnabled()
    this.editor.resetSelectionEnabled()

    this.editingRectShape.setVisible(false)
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

  }

  // Reset the shape creation
  resetShapeEditing() {
    this.editor.component.showToolHelpBox('fa-draw-square', 'Click and drag out the shape')
    //this.editingRectShape.setVisible(false)

    this.editor.flagRenderRequired()
  }

  // onMouseDownEvent
  onMouseDownEvent(ev, mouseData) {
    super.onMouseDownEvent(ev, mouseData)


    this.editor.flagRenderRequired()
  }

  // onMouseMoveEvent
  onMouseMoveEvent(ev, mouseData) {
    super.onMouseMoveEvent(ev, mouseData)

  }

  // onMouseUpEvent
  onMouseUpEvent(ev, mouseData) {
    super.onMouseUpEvent(ev, mouseData)

    this.editor.flagRenderRequired()
  }

  onMouseWheelEvent(ev, mouseData) {
    super.onMouseWheelEvent(ev, mouseData)
  }

  onTouchStartEvent(ev, touchData) {
    super.onTouchStartEvent(ev, touchData)
  }
  onTouchEndEvent(ev, touchData) {
    super.onTouchEndEvent(ev, touchData)
  }
  onTouchCancelEvent(ev, touchData) {
    super.onTouchCancelEvent(ev, touchData)
  }
  onTouchMoveEvent(ev, touchData) {
    super.onTouchMoveEvent(ev, touchData)
  }


  /**
   * Receive an object event from objects we're listening too
   */
  onReceiveObjectEvent(object, eventType, data) {
    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectMoved) {
      if(object == this.editingRectShape) {

        
      }
    }

    if(eventType == GlassDesignerTypes.ObjectEventTypes.objectUpdated) {
      if(object == this.editingRectShape) {

        // Update the frontend UI
        this.displayToolSettingsPopover()
      }
    }
  }


  /**
   * Apply the shape as a boolean operation
   * Either adding & remove the shape from the glass shape
   */
  applyShapeBoolean(addOperation) {

    // Find glass shape closest to the editing shape
    let shape = this.editor.findClosestGlassShape(this.editingRectShape.position)
    if(shape == null)
      throw new EditorUserError('No glass shape found')

    let subjectSegmentList = shape.segmentList
    let clipSegmentList = this.editingRectShape.generateSegmentList()

    let clipper = new EditorClipper()
    let clipResult = clipper.performSegmentListClippingOperation(subjectSegmentList, clipSegmentList, addOperation)

    if(clipResult.segmentList.length == 0) {
      throw new EditorUserError('Cutting shape does not intersect glass')
    }


    // TODO: Check make sure the editing shape is along an edge of the shape (not completely inside/outside)



    // TODO: This
    // TODO: Add edge cutout or corner cutout or something like that
    this.editor.startUndoGroup('Cutting shape')
    this.editor.addUndoShape(shape)
    shape.segmentList = clipResult.segmentList

    this.editor.closeCurrentUndoGroup()
    shape.segmentListUpdated()
    shape.updateSceneObject()
    this.editor.onShapeUpdated(shape)

    this.closeTool()
  }


  // Display the tool settings popover for this tool
  displayToolSettingsPopover() {
    var actionButtons = []

    actionButtons = [
      { title: 'Combine Shape', type: 'update', icon: 'fa-plus-circle', tag: 'add' },
      { title: 'Punch Out Shape', type: 'remove', icon: 'fa-minus-circle', tag: 'remove' }
    ]

    this.editor.component.displayShapeToolPopover({
      title: 'Shape Tool',
      actionButtons: actionButtons,
      angle: this.editingRectShape.angle,
      width: this.editingRectShape.width,
      height: this.editingRectShape.height,
      context: this,
      cancelCallback: (ctx, userCancelled) => {
        if(userCancelled)
          ctx.editor.cancelActiveTool()
      },
      applyCallback: (ctx, info) => {
        if(info.actionTag == 'reset') {
          //ctx.resetCuttingLine()
        } else if(info.actionTag == 'add') {
          ctx.applyShapeBoolean(true)
        } else if(info.actionTag == 'remove') {
          ctx.applyShapeBoolean(false)
          
        } else {
          //ctx.applyCutToShape(info.actionTag == 'inside')
        }
      },
      updateCallback: (ctx, info) => {
        ctx.editingRectShape.angle = info.angle
        ctx.editingRectShape.width = info.width
        ctx.editingRectShape.height = info.height
        ctx.editor.render()
      }
    })
  }

}
